import { CurrencyType } from 'constants/constants';

const calculateCurrencyOptions = (alpha2Code: string, euCountries: string[]) => {
  const isEurCountry = euCountries.includes(alpha2Code);
  const isSweden = alpha2Code === 'SE';
  const options = isSweden
    ? [{ value: CurrencyType.SEK, label: CurrencyType.SEK }]
    : isEurCountry
    ? [{ value: CurrencyType.EUR, label: CurrencyType.EUR }]
    : [
        { value: CurrencyType.EUR, label: CurrencyType.EUR },
        { value: CurrencyType.USD, label: CurrencyType.USD },
      ];

  return options;
};

export default calculateCurrencyOptions;
